// src/router/transportadoras.js

// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['coordenador_operacional']

const transportadorasBreadCrumb = [
    {
        label: 'Home',
        to: 'Home'
    },
    {
        label: 'Transportadoras',
        to: 'Transportadoras'
    }
]

export default [
    {
        path: '/transportadoras',
        name: 'Transportadoras',
        component: () => import('@/views/Transportadoras/TransportadoraListPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Transportadoras',
            breadcrumb: transportadorasBreadCrumb
        },
    },
    {
        path: '/transportadora/nova',
        name: 'TransportadoraNova',
        component: () => import('@/views/Transportadoras/NovaTransportadoraPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Nova Transportadora',
            breadcrumb: [
                ...transportadorasBreadCrumb,
                {
                    label: 'Transportadora',
                    to: 'TransportadoraNova'
                }
            ]
        }
    },
    {
        path: '/transportadora/:id/detalhe',
        name: 'TransportadoraDetalhes',
        component: () => import('@/views/Transportadoras/NovaTransportadoraPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Detalhes da Transportadora',
            breadcrumb: [
                ...transportadorasBreadCrumb,
                {
                    label: 'Nova Transportadoras',
                    to: 'TransportadoraNova'
                }
            ]
        }
    }
];
